export function readSearchString(
  search: unknown,
  key: string,
): string | undefined {
  if (search === null || typeof search !== "object") return undefined;
  const value = (search as Record<string, unknown>)[key];
  if (typeof value === "string" && value !== "") return value;
  return undefined;
}

export function shouldBlockPickSheetLeave(input: {
  isDirty: boolean;
  currentPathname: string;
  nextPathname: string;
  currentPoolId: string | undefined;
  nextPoolId: string | undefined;
  currentView: string | undefined;
  nextView: string | undefined;
}): boolean {
  if (!input.isDirty) return false;
  if (input.nextPathname !== input.currentPathname) return true;
  if ((input.nextPoolId ?? "") !== (input.currentPoolId ?? "")) return true;
  if ((input.nextView ?? "") !== (input.currentView ?? "")) return true;
  return false;
}
